import {
  observer
} from "./chunk-TTXFVJUR.mjs";
import {
  EXIT_DURATION
} from "./chunk-JPXPBBHO.mjs";

// src/hook.ts
import { useCallback, useEffect, useRef, useState } from "react";
function useToastTimer({ toastId, duration }) {
  const startTimeRef = useRef(0);
  const remainingTimeRef = useRef(duration);
  const [interacting, setInteracting] = useState(false);
  const deleteToast = useCallback(() => {
    observer.dismiss(toastId);
    setTimeout(() => {
      observer.delete(toastId);
    }, EXIT_DURATION);
  }, [toastId]);
  useEffect(() => {
    let timerId;
    function startTimer() {
      startTimeRef.current = (/* @__PURE__ */ new Date()).getTime();
      timerId = setTimeout(() => {
        deleteToast();
      }, remainingTimeRef.current);
    }
    function pauseTimer() {
      const currentTime = (/* @__PURE__ */ new Date()).getTime();
      const elapsedTime = currentTime - startTimeRef.current;
      remainingTimeRef.current -= elapsedTime;
    }
    if (interacting) {
      pauseTimer();
    } else {
      startTimer();
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [deleteToast, interacting]);
  const handlePointerDown = useCallback(() => {
    setInteracting(true);
  }, []);
  const handlePointerMove = useCallback(() => {
    setInteracting(true);
  }, []);
  const handlePointerUp = useCallback(() => {
    setInteracting(false);
  }, []);
  const handlePointerOut = useCallback(() => {
    setInteracting(false);
  }, []);
  return {
    onPointerDown: handlePointerDown,
    onPointerMove: handlePointerMove,
    onPointerUp: handlePointerUp,
    onPointerOut: handlePointerOut
  };
}

export {
  useToastTimer
};
